import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import MainHeadlineContent from './MainHeadlineContent'

export default compose(
  withType({ type: 'MainHeadlineContent', placeholders: ['valuePropositionContentBlock', 'heroContentBlock', 'ymmeController']})
)(MainHeadlineContent)
